import HTTP from '../common/http-common';

const END_POINT = '/report';
//== api search ==
const listCarService = (branchCode,status,dateFrom,dateTo) => 
    HTTP.get(END_POINT+"/list-car-service?branchCode="+branchCode+"&status="+status+
                         "&dateFrom="+dateFrom+"&dateTo="+dateTo);

const listTrnConsumable = (branchCode,type,dateFrom,dateTo) => 
    HTTP.get(END_POINT+"/list-transaction-consumable?branchCode="+branchCode+"&type="+type+
                         "&dateFrom="+dateFrom+"&dateTo="+dateTo);

const listTrnPart = (branchCode,dateFrom,dateTo) => 
    HTTP.get(END_POINT+"/list-transaction-part?branchCode="+branchCode+
                         "&dateFrom="+dateFrom+"&dateTo="+dateTo);

const listWithdraw = (branchCode,searchBy,dateFrom,dateTo) => 
    HTTP.get(END_POINT+"/list-withdraw?branchCode="+branchCode+"&searchBy="+searchBy+
                         "&dateFrom="+dateFrom+"&dateTo="+dateTo);

const listWithdrawSummary = (branchCode,type,dateFrom,dateTo) => 
    HTTP.get(END_POINT+"/list-withdraw-summary?branchCode="+branchCode+"&type="+type+
                         "&dateFrom="+dateFrom+"&dateTo="+dateTo);

const listJobImage = (branchCode, jobNo) => 
    HTTP.get(END_POINT + "/list-job-image?branchCode=" + branchCode + "&jobNo=" + jobNo);
                         
//=== export section ==
const exportCarService = (branchCode,branchName,status,dateFrom,dateTo) => 
    HTTP.get(END_POINT+"/export-car-service?branchCode="+branchCode+"&branchName="+branchName+"&status="+status+
                         "&dateFrom="+dateFrom+"&dateTo="+dateTo , {
                            responseType: 'blob'
                        }).then((response) => {
                            const url = URL.createObjectURL(new Blob([response], {
                                type: 'application/octet-stream'
                            }))
                            const link = document.createElement('a')
                            link.href = url
                            link.setAttribute('download', 'รายงานรถเข้าซ่อม-ซ่อมเสร็จ.xlsx');
                            document.body.appendChild(link)
                            link.click()
                        });

// const exportTrnConsumable = (branchCode,type,dateFrom,dateTo) => 
//     HTTP.get(END_POINT+"/export-transaction-consumable?branchCode="+branchCode+"&type="+type+
//                          "&dateFrom="+dateFrom+"&dateTo="+dateTo);

const exportTrnConsumable = (branchCode,branchName,type,dateFrom,dateTo) => 
    HTTP.get(END_POINT+"/export-transaction-consumable?branchCode="+branchCode+"&branchName="+branchName+"&type="+type+
                         "&dateFrom="+dateFrom+"&dateTo="+dateTo , {
                            responseType: 'blob'
                        }).then((response) => {
                            const url = URL.createObjectURL(new Blob([response], {
                                type: 'application/octet-stream'
                            }))
                            const link = document.createElement('a')
                            link.href = url
                            link.setAttribute('download', 'รายงานวัสดุสิ้นเปลือง เข้า-ออก.xlsx');
                            document.body.appendChild(link)
                            link.click()
                        });

const exportTrnPart = (branchCode,branchName,dateFrom,dateTo) => 
    HTTP.get(END_POINT+"/export-transaction-part?branchCode="+branchCode+"&branchName="+branchName+
                         "&dateFrom="+dateFrom+"&dateTo="+dateTo , {
                            responseType: 'blob'
                        }).then((response) => {
                            const url = URL.createObjectURL(new Blob([response], {
                                type: 'application/octet-stream'
                            }))
                            const link = document.createElement('a')
                            link.href = url
                            link.setAttribute('download', 'รายงานอะไหล่เข้า-ออก.xlsx');
                            document.body.appendChild(link)
                            link.click()
                        });

const exportWithdraw = (branchCode,branchName,searchBy,dateFrom,dateTo) => 
    HTTP.get(END_POINT+"/export-withdraw?branchCode="+branchCode+"&branchName="+branchName+"&searchBy="+searchBy+
                         "&dateFrom="+dateFrom+"&dateTo="+dateTo , {
                            responseType: 'blob'
                        }).then((response) => {
                            const url = URL.createObjectURL(new Blob([response], {
                                type: 'application/octet-stream'
                            }))
                            const link = document.createElement('a')
                            link.href = url
                            link.setAttribute('download', 'รายงานการตั้งเบิก(ภายใน).xlsx');
                            document.body.appendChild(link)
                            link.click()
                        });

const exportWithdrawSummary = (branchCode,branchName,type,dateFrom,dateTo) => 
    HTTP.get(END_POINT+"/export-withdraw-summary?branchCode="+branchCode+"&branchName="+branchName+"&type="+type+
                         "&dateFrom="+dateFrom+"&dateTo="+dateTo , {
                            responseType: 'blob'
                        }).then((response) => {
                            const url = URL.createObjectURL(new Blob([response], {
                                type: 'application/octet-stream'
                            }))
                            const link = document.createElement('a')
                            link.href = url
                            link.setAttribute('download', 'รายงานการตั้งเบิก(ส่งศูนย์).xlsx');
                            document.body.appendChild(link)
                            link.click()
                        });

const exportJobImage = (branchCode, jobNo) => 
    HTTP.get(END_POINT + "/job-image?branchCode=" + branchCode + "&jobNo=" + jobNo, {
        responseType: 'blob'
    }).then((response) => {
        const url = URL.createObjectURL(new Blob([response], {
            type: 'application/pdf'
        }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'รายงานภาพงานซ่อม_' + jobNo + '.pdf');
        document.body.appendChild(link)
        link.click()
    });

    const listControllerReport = (branchCode, carStatus) => HTTP.get(END_POINT + "/list-controller-report?branchCode=" + branchCode + "&carStatus=" + carStatus);
    
    const exportControllerReport = (branchCode,branchName,date) => 
    HTTP.get(END_POINT+"/controllerBoard?branchCode="+branchCode+"&branchName="+branchName+"&date="+date , {
                            responseType: 'blob'
                        }).then((response) => {
                            const url = URL.createObjectURL(new Blob([response], {
                                type: 'application/octet-stream'
                            }))
                            const link = document.createElement('a')
                            link.href = url
                            link.setAttribute('download', 'รายงาน controller.xlsx');
                            document.body.appendChild(link)
                            link.click()
                        });

export {
    listCarService,
    listTrnConsumable,
     listTrnPart,
    listWithdraw,
    listWithdrawSummary,
    listJobImage,

    exportCarService,
    exportTrnConsumable,
     exportTrnPart,
    exportWithdraw,
    exportWithdrawSummary,
    exportJobImage,

    listControllerReport,
    exportControllerReport
}